import { rem } from 'polished'

/**
 * Minimum right-panel width that can host the desktop multi-column list table
 * without cutting content. Below this, desktop snaps to the mobile card list.
 */
export const TRIP_LIST_DESKTOP_LAYOUT_MIN_WIDTH = 780

export const TRIP_LIST_MIN_WIDTH = rem(TRIP_LIST_DESKTOP_LAYOUT_MIN_WIDTH)
/**
 * Trip Kit 3.0 desktop table columns, straight off the Figma `.TableRow`:
 * a 32px selection gutter, a 120px date column, the type/title column taking
 * the remaining space, then status (120-130), price (120-140) and action
 * (120-130).
 */
export const TRIP_LIST_GRID_COLUMNS = `${rem(32)} ${rem(120)} minmax(${rem(220)}, 1fr) minmax(${rem(120)}, ${rem(130)}) minmax(${rem(120)}, ${rem(140)}) minmax(${rem(120)}, ${rem(130)})`
export const TRIP_LIST_CONTENT_GRID_COLUMNS = `minmax(${rem(220)}, 1fr) minmax(${rem(120)}, ${rem(130)}) minmax(${rem(120)}, ${rem(140)}) minmax(${rem(120)}, ${rem(130)})`

/**
 * Horizontal gutter every band of the mobile list shares -- toolbar, stop header,
 * day heading and the cards themselves -- so their content sits on one left edge.
 * Kept here rather than inline so a change to one band can't silently un-align
 * it from the rest.
 */
export const TRIP_LIST_MOBILE_INLINE_PADDING = 12
